import React, { useState } from "react"
import { Tuple } from "components/Shared/Interfaces"
import {
	AGE,
	GENDER,
	PSYCHOGRAPHICS,
	CUSTOMER_TYPE,
} from "components/Shared/GlobalFilter/constants"
import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"
import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"
import { OPTIONS } from "../options"
import PanelContent from "components/Shared/Filters/modules/components"
import Checkbox from "components/Shared/Filters/Checkbox"
import Radio from "components/Shared/Filters/Radio"
import { isDisabledTypeOfCustomer } from "./utils"
import { useLocation } from "react-router"
import "./index.scss"

interface SegmentationProps {
	setStoreFilters?: (key: string, filters: Array<Tuple>) => void
	customCodes?: Record<string, Array<string>>
}

const Segmentation: React.FC<SegmentationProps> = ({
	setStoreFilters,
	customCodes,
}) => {
	const { filters, moduleState } = useFiltersContext()
	const location = useLocation()
	const [selectedValues, setSelectedValues] = useState<FiltersType>(filters)

	const handleFilters = (filterId: string, selectedFilters: Array<Tuple>) => {
		setSelectedValues({ ...selectedValues, [filterId]: selectedFilters })
		setStoreFilters && setStoreFilters(filterId, selectedFilters)
	}

	return (
		<div className="filter-segmentation">
			<PanelContent id={AGE} selectedValues={selectedValues.age} isCollapsable>
				<Checkbox
					id={AGE}
					onChange={(value: Tuple[]) => handleFilters(AGE, value)}
					options={OPTIONS(AGE, customCodes)}
					defaultValue={selectedValues.age}
					hasTitle={false}
					allOption
				/>
			</PanelContent>
			<PanelContent
				id={GENDER}
				selectedValues={selectedValues.gender}
				isCollapsable
			>
				<Checkbox
					id={GENDER}
					onChange={(value: Tuple[]) => handleFilters(GENDER, value)}
					options={OPTIONS(GENDER, customCodes)}
					defaultValue={selectedValues.gender}
					hasTitle={false}
					allOption
				/>
			</PanelContent>
			<PanelContent
				id={PSYCHOGRAPHICS}
				selectedValues={selectedValues.psychographics}
				isCollapsable
			>
				<Checkbox
					id={PSYCHOGRAPHICS}
					onChange={(value: Tuple[]) => handleFilters(PSYCHOGRAPHICS, value)}
					options={OPTIONS(PSYCHOGRAPHICS, customCodes)}
					defaultValue={selectedValues.psychographics}
					hasTitle={false}
					allOption
				/>
			</PanelContent>
			<PanelContent
				id={CUSTOMER_TYPE}
				selectedValues={selectedValues.customer_type}
				isCollapsable
				isDisabled={isDisabledTypeOfCustomer(moduleState, location)}
			>
				<Radio
					id={CUSTOMER_TYPE}
					onChange={(value: Tuple[]) => handleFilters(CUSTOMER_TYPE, value)}
					options={OPTIONS(CUSTOMER_TYPE, customCodes)}
					defaultValue={selectedValues.customer_type}
					hasTitle={false}
					allOption
				/>
			</PanelContent>
		</div>
	)
}

export default Segmentation
